import create from '@verndale/core';
import modules from './ms-modules';

let modulesCreated = false;

document.addEventListener('DOMContentLoaded', () => {
  if (modulesCreated) return;
  modulesCreated = true;
  const main = document.querySelector('main');
  if (main?.dataset.animationSelectors?.length > 0) {
    const selectors = document
      .querySelector('main')
      .dataset.animationSelectors.trim()
      .split(',');
    selectors.forEach(elementSelector => {
      elementSelector.trim();
      document
        .querySelectorAll(elementSelector)
        .forEach((element: HTMLElement) => {
          element.setAttribute('data-module', 'ms-animator');
          element.setAttribute(
            'data-animation',
            main.dataset.animation || 'fade'
          );
          element.classList.add(main.dataset.animation || 'fade');
        });
    });
  }

  create(modules);
  if (main?.dataset.animationSelectors?.length > 0) {
    requestAnimationFrame(() => {
      setTimeout(() => {
        main.style.opacity = '1';
      }, 100);
    });
  }
});
